<template>
  <div>
    请稍等...
  </div>
</template>

<script>
import { queryTemplateDetail } from '@/api/api'

export default {
  components: {},
  data() {
    return {}
  },
  async mounted() {
    const code = this.$route.query.code
    if (code) {
      await window.localStorage.setItem('activityCode', code)
      this.queryTemplateDetailFun(code)
      return
    }
    this.$message({
      type: 'info',
      message: '暂无活动'
    })
  },
  methods: {
    queryTemplateDetailFun(code) {
      queryTemplateDetail({ activityCode: code }).then(res => {
        if (res.data.pagePath) {
          this.$router.push({ path: res.data.pagePath })
        } else {
          this.$message({
            type: 'info',
            message: '暂无活动'
          })
        }
      })
    }
  }
}
</script>

<style scoped="scoped" lang="less">
</style>
